import styled from 'styled-components';

import { colors, fontSizes } from 'ui/theme';

import { SubscriptionPolicy } from '../../../../domain';
import { Cell } from '../../../../components/table';
import { TableColumn } from './constants';
import { POLICY_DISPLAY_NAMES } from '../../../constants';

const PolicyName = styled.div`
  font-size: ${fontSizes.s14};
  color: ${colors.textPrimary};
`;

type PolicyCellProps = {
  subscriptionPolicy: SubscriptionPolicy;
};

export const PolicyCell = ({ subscriptionPolicy }: PolicyCellProps) => (
  <Cell columnId={TableColumn.subscriptionPolicy}>
    <PolicyName>{POLICY_DISPLAY_NAMES[subscriptionPolicy]}</PolicyName>
  </Cell>
);
